import React from 'react';
import { ContactHero } from '../components/contact/ContactHero';
import { ContactInfo } from '../components/contact/ContactInfo';
import { ContactMap } from '../components/contact/ContactMap';

export const ContactPage = () => {
  return (
    <div className="min-h-screen pt-20">
      <ContactHero />
      <ContactInfo />
      <ContactMap />
    </div>
  );
};
